export default "__VITE_ASSET__BWQx_kUb__"